"use client";

import { useMemo } from "react";
import type { QuizAnswers } from "@/src/components/OnboardingWizard/types";
import {
  scoreOnboardingGoals,
  type ScoredGoalHook,
} from "./scoreOnboardingGoals";

export interface OnboardingGoalScoringResult {
  scoredGoals: ScoredGoalHook[];
  leadId: string;
  leadHookId: string;
}

export const useOnboardingGoalScoring = (
  answers: QuizAnswers,
): OnboardingGoalScoringResult =>
  useMemo(() => {
    const scoredGoals = scoreOnboardingGoals(answers);
    const lead = scoredGoals[0];
    return {
      scoredGoals,
      leadId: lead?.option.id ?? "",
      leadHookId: lead?.hookId ?? "million",
    };
  }, [answers]);
